import { ISize } from "./MyHelpers";
import { assertEqual, assertNever } from "./debug";
import { Classic } from "./settings/Classic";

export type FitType = "none" | "fit" | "stretch";

export interface DoubleUpMiscellaneous{
    readonly ShowLastBigCard: boolean;
}

export type WarningMessage = "malfunction" | "amusement" ;

export enum ScreenConfiguration
{
    SeparateScreens,
    CombinedScreen
}

export const enum JackpotDisplayType
{
    PreciousSpin = "PreciousSpin",
    DiamondPot = "DiamondPot",
    DiamondPotOrtiz = "DiamondPotOrtiz",    
    DragonJackpot = "DragonJackpot",
    DiamondPotStep = "DiamondPotStep",
    DiamondPotCaliente = "DiamondPotCaliente",
    DiamondPotPlayCity = "DiamondPotPlayCity",
    PlayCityLink = "PlayCityLink",
    PlayCityLinkResponsive = "PlayCityLinkResponsive",
    PlayCityLinkResponsivePIXI = "PlayCityLinkResponsivePIXI",
    JubileeLink = "JubileeLink",
    JubileeLinkResponsive = "JubileeLinkResponsive",
    JubileeLinkResponsivePIXI = "JubileeLinkResponsivePIXI",
    DiamondPotJubilee = "DiamondPotJubilee",
    PaytableJackpotDisplay = "PaytableJackpotDisplay",
    ViventoLink = "ViventoLink",
    RapidDiamondPot = "RapidDiamondPot",
    RapidDiamondPot2 = "RapidDiamondPot2",
    RapidDiamondPotStep = "RapidDiamondPotStep",
    RapidDiamondPotFire = "RapidDiamondPotFire",
    DiamondPotRappidFrames = "DiamondPotRappidFrames",    
    DiamondPotStepRappidFrames = "DiamondPotStepRappidFrames",    
    RapidDiamondPotStep2 = "RapidDiamondPotStep2",
    RainbowGirls = "RainbowGirls",
    DiamondPotStepShared = "DiamondPotStepShared",
    DiamondPotStepSinShared = "DiamondPotStepSinShared",
    DiamondPotResponsive = "DiamondPotResponsive",
    DiamondPotResponsivePIXI = "DiamondPotResponsivePIXI",
    DiamondPotResponsivePIXIHorizontal = "DiamondPotResponsivePIXIHorizontal",
    DiamondPotStepRappidFramesSpine = "DiamondPotStepRappidFramesSpine",   
    DiamondPotRappidFramesSpine = "DiamondPotRappidFramesSpine",
    DiamondPotStepSharedSpineV2 = "DiamondPotStepSharedSpineV2",
    DiamondPotStepSinSharedSpineV2 = "DiamondPotStepSinSharedSpineV2", 
    DiamondPotPyramidShared = "DiamondPotPyramidShared",
    DiamondPotPyramidSinShared = "DiamondPotPyramidSinShared",
    DiamondPotPyramidJP4ShareJP3SinShared = "DiamondPotPyramidJP4ShareJP3SinShared",   
    DiamondPotPyramidShared2S = "DiamondPotPyramidShared2S",
    DiamondPotPyramidSinShared2S = "DiamondPotPyramidSinShared2S",
    DiamondPotPyramidJP4SharedJP3SinShared2S = "DiamondPotPyramidJP4SharedJP3SinShared2S",
    DiamondPotPyramidSinSharedResponsive = "DiamondPotPyramidSinSharedResponsive",
    JubileeLinkResponsivePIXIAPPHorizontal = "JubileeLinkResponsivePIXIAPPHorizontal",
    JackpotDisplayPlayCityPIXIAPPHorizontal = "JackpotDisplayPlayCityPIXIAPPHorizontal",
    JackpotDisplayRapidLinkPIXIAPPHorizontal = "JackpotDisplayRapidLinkPIXIAPPHorizontal",
    MysticPortalLinkHorizontal = "MysticPortalLinkHorizontal",
    MysticPortalLink3S = "MysticPortalLink3S",
    MysticPortalResponsive = "MysticPortalResponsive",
}

export enum WallDisplayType
{
    PreciousSpin = "PreciousSpin",
    DiamondPotOrtiz = "DiamondPotOrtiz",
    DiamondPot = "DiamondPot",
    DragonJackpot = "DragonJackpot",
    DiamondPotJubilee = "DiamondPotJubilee",
    DiamondPotCaliente = "DiamondPotCaliente",
    DiamondPotPlayCity = "DiamondPotPlayCity",
    JubileeLink = "JubileeLink",
    ViventoLink = "ViventoLink",
    FirenzeLink = "FirenzeLink",
}

export  enum SourcePickbonus
{
    Ortiz = "Ortiz",
    DragonLink = "DragonLink"
}

export enum JackpotDisplay
{
    Enable = "Enable",
    Disable = "Disable"
}

export enum MenuType{
    OrtizMenu = "OrtizMenu",
    JubileeMenu = "JubileeMenu",
    PyramidMenu = "PyramidMenu",
    DummyMenu = "DummyMenu",
    CalienteMenu = "CalienteMenu",
    PlayCityLinkMenu = "PlayCityLinkMenu",
    PlayCityLinkBigMenu = "PlayCityLinkBigMenu",
    ViventoMenu = "ViventoMenu",
    SliderMenu = "SliderMenu",
    BigAnimatedMenu = "BigAnimatedMenu",
    ClassicMenu = "ClassicMenu",
    EternalFortuneMenu = "EternalFortuneMenu",
    BigAnimatedMysticMenu = "BigAnimatedMysticMenu",
    MysticMenu = "MysticMenu",
    BigAnimatedAsianMenu = "BigAnimatedAsianMenu",
    BigAnimatedMenuPurple = "BigAnimatedMenuPurple",
    ScrollingMenu = "ScrollingMenu",
    InGameMenu = "InGameMenu",
}

export enum PanelType
{
    DefaultBluePanel = "DefaultBluePanel",
    DefaultTransparentPanel = "DefaultTransparentPanel",
    Pyramid = "Pyramid",
    Online = "Online",
    OnlineResponsive = "OnlineResponsive",
    // Online2 = "Online2",
    OnlineMoney = "OnlineMoney",
    OnlineGamesMenu = "OnlineGamesMenu",
    OnlineJubilee = "OnlineJubilee",
    BluePanelSingleGame = "BluePanelSingleGame",
    DefaultGameColorPanel = "DefaultGameColorPanel",
    OnlineResponsive5buttons ="PanelOnlineResponsive5buttons",
    OnlineResponsive5buttons1Line = "OnlineResponsive5buttons1Line",
    Ortiz = "Ortiz"
    //OnlineJubilee = "OnlineJubilee",
}

// export enum LanguageInit
// {
//     SpanishTranslation,
//     EnglishTranslation,
//     RomanianTranslation,
// }
/*** transicion and presentation type :
 * VideoGameSprite= VideoGame+SpriteBonus,
 * Img:Image GameBackground ,
 * VideoCommonNoSprite = VideoCommonNoSprite its commonVideo
 * VideoCommonClassic= VideoComon + SpriteBonus ,     */

export enum Presentation {
    VideoGameSprite = "VideoGameSprite",
    Image = "Image",
    VideoCommonNoSprite = "VideoCommonNoSprite",
    VideoCommonClassic = "VideoCommonClassic",
    VideoNoSprite = "VideoNoSprite",
    VideoParticleTransitionMatterJS = "VideoParticleTransitionMatterJS",
    VideoParticleTransitionFadeInFadeOut = "VideoParticleTransitionFadeInFadeOut",
    VideoParticleTransitionFadeInFadeOutResponsive = "VideoParticleTransitionFadeInFadeOutResponsive",
    JackpotTransitionSpineAnimationResponsive = "JackpotTransitionSpineAnimationResponsive"
}

export enum DisplayAmount
{
    AsCredits = "AsCredits",
    AsMoney = "AsMoney"
}

/** enable or disable virtual bottonera */
export enum VirtualBotoneraType{
    BigButtons = "BigButtons",
    Disable = "Disable",
}

/*** small sliders for info game on GameScreen2  for slot whit 3 and 2 screens */ 
export enum InfoScreenSlider{
    EnableScreen3 ="EnableScreen3",
    EnableScreen2 ="EnableScreen2",
    //Enable ="Enable",
    Disable ="Disable",
    //FillingPotFeature = "FillingPotFeature",
}

export enum TitleGameSlide{
    Enable = "Enable",
    Disable = "Disable",
}

export enum WinLinesType{
    WinLinesAnimation = "WinLinesAnimation",
    WinSquareAnimations = "WinSquareAnimations",
    WinSquareMarkesAnimations = "WinSquareMarkesAnimations",
    WinNumberLinesAnimation = "WinNumberLinesAnimation",
    WinSquare1MarkeAnimations = "WinSquare1MarkeAnimations",    
    WinSquareAnimationsLineLoopLimited = "WinSquareAnimationsLimited",
    WinSquaresAnimationsSpinePIXIAPPGridLineLoopLimited = "WinSquaresAnimationsSpinePIXIAPPGridLineLoopLimited",
    WinSquaresAnimationsSpinePIXIAPPGridLimited = "WinSquaresAnimationsSpinePIXIAPPGridLimited",
}

/*** change how will looks GameScreen3 or JackpotScreen for slot whit 3Screen   */ 
export enum Screen3SettingDisplay{
    JackpotDisplay,
    GameTitleJackpot,
}

export enum FillingPotFeature {
    Enable,    
    Disable,
}

export type ScreenHeightType = 1080 | 720 | 540 | 608;
export type ScreenWidthType  = 1920 | 1280 | 960 | 1080;

export enum CometStyles
{
    PurpleStyle = "PurpleStyle",
    BlueStyle = "BlueStyle",
    PurpleStylePIXI = "PurpleStylePIXI",
    BlueStylePIXI = "BlueStylePIXI",
    BlueStylePIXIResponsive = "BlueStylePIXIResponsive",
    Spine="Spine"
}
 
export interface ISettings extends DoubleUpMiscellaneous
{
    readonly ShowLastBigCard: boolean;
    readonly SettingsName: string;

    readonly ScreenConfiguration: ScreenConfiguration;
    readonly JackpotDisplayType: JackpotDisplayType;
    readonly MenuType : MenuType;
    readonly PanelType: PanelType;
	
    readonly Screens: number;
	readonly ScreenHeight: ScreenHeightType;
	readonly ScreenWidth: ScreenWidthType;
    readonly SourcePick: SourcePickbonus;
    
    readonly WallDisplayType: WallDisplayType;
    readonly WallDisplayScreens: number;
    readonly WallDisplaySize: ISize;

	readonly ResourcesFolder: string;
	readonly SpriteFrameDebugging: boolean;
    readonly ConsoleLogging: boolean;

    readonly OnlineControls: boolean;
    readonly EndlessFitting: boolean;
    readonly KeyboardEnabled: boolean;
    readonly PresentationType : Presentation;

    readonly EnablePanelWithSettings: boolean;

    readonly DisplayAmount: DisplayAmount;

    readonly JackpotDisplay: JackpotDisplay;
    readonly VirtualBotoneraType: VirtualBotoneraType;

    readonly JackpotSlider: InfoScreenSlider;
    readonly bottoneraFakeSize: ISize;
    readonly bottoneraRealSize: ISize;

    readonly FailOnConnectionLost: boolean;

    readonly Server: string | (() => string);

    // readonly PayoutButtonEnabled : boolean;
    readonly touchToStop : boolean;

    readonly titleGameSlide : boolean ;
    readonly winLinesType : WinLinesType;
    readonly videoFormat: ".webm" | ".mp4";
    readonly DefaultFitType: FitType;
    readonly audioFormat: ".ogg" | ".mp3";
    readonly warningMessage: WarningMessage;
    readonly skipCommet: boolean;
    readonly screen3Display : Screen3SettingDisplay;
    readonly fillingPotFeature : FillingPotFeature;

    readonly menuGameSelectPresentation: boolean;

    /** change the resources for bonusWin Show Extendend and spinAndHold */
    readonly cometStyle : CometStyles; 

    readonly autoPlaySkipWinLines : boolean;
    readonly Enable2plus1: boolean;
    readonly PauseBackgroundSound : boolean;
    readonly ShowMinBetInfo: boolean;
}

//settings para RapidLink
//Settings New Jackpot 
//2lus1Settings
//Settings PP
//2lus1Settings-PP
//JP4Share JP3SinShare
//End New Settings Jackpot 
export class SettingsFactory
{
    public constructor()
    {

    }
    // protected PlayCityLimit: string[] = ["PlayCityHighLimit", "PlayCityNormalLimit"]
    // protected JubileeLimit: string[]= ["JubileeHighLimit", "JubileeNormalLimit"]
    

    public CreateDefaultSettings(): ISettings
    {
        return new Classic();
    }

    

    public async CreateSettings(settingsName = null): Promise<ISettings>
    {
        const urlParams = new URLSearchParams(window.location.search);
        let settings: ISettings;
        let requestedSettings = settingsName ?? urlParams?.get("settings");

        // if (!requestedSettings)
        // {
        //     throw "No settings name provided to settings factory";
        // }
       
        //let getGameName = urlParams?.get("gameName") ?? urlParams.get("gameCode");

        



        //let onlineLimit = getGameName.slice(0, this.PlayCityLimit.find(x => getGameName.includes(x))?.length); 

        // if (getGameName.slice(0, this.PlayCityLimit.find(x => getGameName.includes(x))?.length)){
        //     isPlayCityOnlineGame = true
        // }
        // else if (getGameName.slice(0, this.JubileeLimit.find(x => getGameName.includes(x))?.length))
        // {
        //     isJubileeOnlineGame = true
        // }

        if (requestedSettings == "online-1s")
        {
            settings = new (await import("./settings/Settings_OnlineSignleScreen")).Settings_OnlineSignleScreen();
        }
        else if (requestedSettings == "online")
        {
            settings = new (await import("./settings/Settings_Online")).Settings_Online();
        }
        else if (requestedSettings == "DiamondPot")
        {
            settings = new (await import("./settings/DiamondPot")).DiamondPot();
        }
        else if (requestedSettings == "MultiBonus")
        {
            settings = new (await import("./settings/MultiBonus")).MultiBonus();
        }
        else if (requestedSettings == "FillingPot")
        {
            settings = new (await import("./settings/FillingPot")).FillingPot();
        }
         else if (requestedSettings == "RapidLink")
        {
            settings = new (await import("./settings/RapidLink")).RapidLink();
        }
        else if (requestedSettings == "Jubilee")
        {
            settings = new (await import("./settings/Jubilee")).Jubilee();
        }
        else if (requestedSettings == "PlayCity")
        {
            settings = new (await import("./settings/PlayCity")).PlayCity();
        }
        else if (requestedSettings == "Portal")
        {
            settings = new (await import("./settings/Portal")).Portal();
        }
        else if (requestedSettings == "PlayCityMultiBonus")
        {
            settings = new (await import("./settings/PlayCityMultiBonus")).PlayCityMultiBonus();
        }
        else if (requestedSettings == "Classic")
        {
            settings = new (await import("./settings/Classic")).Classic();
        }
        else if (requestedSettings == "onlineclassic")
        {
            settings = new (await import("./settings/Classic")).Classic();
        }
        else if (requestedSettings == "online-2s")
        {
            settings = new (await import("./settings/Settings_OnlineDoubleScreen")).Settings_OnlineDoubleScreen();
        }
        else if (requestedSettings == "online-3s")
        {
            settings = new (await import("./settings/Settings_OnlineTrippleScreen")).Settings_OnlineTrippleScreen();
        }
        else if (requestedSettings == "online-2s-diamondpot")
        {
            settings = new (await import("./settings/Settings_OnlineDoubleScreenDiamond")).Settings_OnlineDoubleScreenDiamond();
        }
        else if (requestedSettings == "online-3s-diamondpot")
        {
            settings = new (await import("./settings/Settings_OnlineTrippleScreenDiamond")).Settings_OnlineTrippleScreenDiamond();
        }
        else if (requestedSettings == "marko")
        {
            settings = new (await import("./settings/Settings_Marko")).Settings_Marko();
        }
        else if (requestedSettings == "caliente")
        {
            settings = new (await import("./settings/Settings_Caliente")).Settings_Caliente();
        }
        else if (requestedSettings == "playcitylink3spanel")
        {
            settings = new (await import("./settings/Settings_PlayCityLink3SCurvePanelBottonera")).Settings_PlayCityLink3SCurvePanelBottonera();
        }
        else if (requestedSettings == "playcitylink3svirtual")
        {
            settings = new (await import("./settings/Settings_PlayCityLink3SCurveVirtualBottonera")).Settings_PlayCityLink3SCurveVirtualBottonera();
        }
        else if (requestedSettings == "usa")
        {
            settings = new (await import("./settings/Settings_USA")).Settings_USA();
        }
        else if (requestedSettings == "usa2")
        {
            settings = new (await import("./settings/Settings_USARapidLink")).Settings_USARapidLink();
        }
        else if (requestedSettings == "usa2botonera")
        {
            settings = new (await import("./settings/Settings_USARapidLinkBotonera")).Settings_USARapidLinkBotonera();
        }
        else if (requestedSettings == "usa2pga")
        {
            settings = new (await import("./settings/Settings_USARapidLinkPGA")).Settings_USARapidLinkPGA();
        }
        else if (requestedSettings == "jubileelink")
        {
            settings = new (await import("./settings/Settings_JubileeLink")).Settings_JubileeLink();
        }
        else if (requestedSettings == "jubileelink2s")
        {
            settings = new (await import("./settings/Settings_JubileeLink_2S")).Settings_JubileeLink_2S();
        }
        else if (requestedSettings == "viventolink2s")
        {
            settings = new (await import("./settings/Settings_ViventoLink_2S")).Settings_ViventoLink_2S();
        }
        else if (requestedSettings == "viventolink3s")
        {
            settings = new (await import("./settings/Settings_ViventoLink_3S")).Settings_ViventoLink_3S();
        }
        else if (requestedSettings == "quixant")
        {
            settings = new (await import("./settings/Settings_Quixant_2S")).Settings_Quixant_2S();
        }
        else if (requestedSettings == "classic3s")
        {
            settings = new (await import("./settings/Settings_ClassicNoJackpot3S")).Settings_ClassicNoJackpot3S();
        }
        else if (requestedSettings == "classic2s")
        {
            settings = new (await import("./settings/Settings_ClassicNoJackpot2S")).Settings_ClassicNoJackpot2S();
        }
        else if (requestedSettings == "classic2sdrei")
        {
            settings = new (await import("./settings/Settings_ClassicNoJackpot2Sdreidel")).Settings_ClassicNoJackpot2Sdreidel();
        }
        else if (requestedSettings == "classicfreegame")
        {
            settings = new (await import("./settings/Settings_ClassicFreeGames")).Settings_ClassicFreeGames();
        }else if(requestedSettings == "firenze")
        {
            settings = new (await import("./settings/Settings_Firenze")).Settings_Firenze();
        }else if(requestedSettings == "tornado32")
        {
            settings = new (await import("./settings/Settings_Tornado32")).Settings_Tornado32();
        }
        else if(requestedSettings == "autlanrap")
        {
            settings = new (await import("./settings/Settings_AutlanRapidLink")).Settings_AutlanRapidLink();
        }
        else if(requestedSettings == "autlandia")
        {
            settings = new (await import("./settings/Settings_AutlanDiamondPot")).Settings_AutlanDiamondPot();
        }
        else if(requestedSettings == "colombia")
        {
            settings = new (await import("./settings/Settings_Colombia")).Settings_Colombia();
        }
        else if(requestedSettings == "eternal")
        {
            settings = new (await import("./settings/Settings_Eternal")).Settings_Eternal();
        }
        else if(requestedSettings == "rapidfire2s")
        {
            settings = new (await import("./settings/Settings_RapidLinkFire2S")).Settings_RapidLinkFire2S();
        }
        else if(requestedSettings == "rapidfire2s-virtualbotonera")
        {
            settings = new (await import("./settings/Settings_RapidLinkFire2SVirtualBotonera")).Settings_RapidLinkFire2SVirtualBotonera();
        }
        else if(requestedSettings == "rapidfire3s")
        {
            settings = new (await import("./settings/Settings_RapidLinkFire3S")).Settings_RapidLinkFire3S();
        }
        else if(requestedSettings == "rapidmystic")
        {

            settings = new (await import("./settings/Settings_RapidLinkMysticMenu3S")).Settings_RapidLinkMysticMenu3S();
        }
        else if (requestedSettings == "rapidbigmystic")
        {
            settings = new (await import("./settings/Settings_RapidLinkBigMysticMenu3S")).Settings_RapidLinkBigMysticMenu3S();
        }
        else if (requestedSettings == "rapidbigasian")
        {
            settings = new (await import("./settings/Settings_RapidLinkBigAsianMenu3S")).Settings_RapidLinkBigAsianMenu3S();
        }
        else if (requestedSettings == "tequila")
        {
            settings = new (await import("./settings/Settings_Tequila")).Settings_Tequila();
        }
        else if (requestedSettings == "rapidbigmysticcurve")
        {
            settings = new (await import("./settings/Settings_RapidLinkBigMysticMenu3SCurve")).Settings_RapidLinkBigMysticMenu3SCurve();
        }
        else if (requestedSettings == "sanignaciodia")
        {
            settings = new (await import("./settings/Settings_SanIgnacioDiamondPotStep")).Settings_SanIgnacioDiamondPotStep();
        }
        else if (requestedSettings == "trinidad")
        {
            settings = new (await import("./settings/Settings_Trinidad")).Settings_Trinidad();
        }
        else if (requestedSettings == "firenzepga")
        {
            settings = new (await import("./settings/Settings_FirenzePGA")).Settings_FirenzePGA();
        }
        else if (requestedSettings == "apatzingandreidel")
        {
            settings = new (await import("./settings/Settings_ApatzinganDreidel")).Settings_ApatzinganDreidel();
        }
        else if (requestedSettings == "bigmenudiamondpot")
        {
            settings = new (await import("./settings/Settings_BigAnimatedMenuDiamondPot")).Settings_BigAnimatedMenuDiamondPot();
        }
        else if (requestedSettings == "bigmenurapid2s")
        {
            settings = new (await import("./settings/Settings_RapindLinkBigMenu2S")).Settings_RapindLinkBigMenu2S();
        }
        else if (requestedSettings == "rumanialink3s")
        {
            settings = new (await import("./settings/Settings_RumaniaLink3s")).Settings_RumaniaLink3s();
        }
        else if (requestedSettings == "rumanialink2s")
        {
            settings = new (await import("./settings/Settings_RumaniaLink2s")).Settings_RumaniaLink2s();
        }
        else if (requestedSettings == "usa1080")
        {
            settings = new (await import("./settings/Settings_USARapidLink1080")).Settings_USARapidLink1080();
        }
        else if (requestedSettings == "fillingpot3s-1080")
        {
            settings = new (await import("./settings/Settings_FillingPot1080")).Settings_FillingPot1080();
        }
        else if (requestedSettings == "fillingpot3s-720")
        {
            settings = new (await import("./settings/Settings_FillingPot720")).Settings_FillingPot720();
        }
        else if (requestedSettings == "fillingpot3s-720-pp")
        {
            settings = new (await import("./settings/Settings_FillingPot720_PP")).Settings_FillingPot720_PP();
        }
        else if (requestedSettings == "fillingpotdiamond3s-720-2p1")
        {
            settings = new (await import("./settings/Settings_FillingPot_DiamondPot_3S_720_2p1")).Settings_FillingPot_DiamondPot_3S_720_2p1();
        }
        else if (requestedSettings == "fillingpotdiamond3s-720-2p1-pp")
        {
            settings = new (await import("./settings/Settings_FillingPot_DiamondPot_3S_720_2p1_PP")).Settings_FillingPot_DiamondPot_3S_720_2p1_PP();
        }
        else if (requestedSettings == "fillingpotrainbowgirls3s-1080")
        {
            settings = new (await import("./settings/Settings_RainbowGirls3s_1080")).Settings_RainbowGirls3s_1080();
        }
        else if (requestedSettings == "fillingpotrainbowgirls3s-1080-pp")
        {
            settings = new (await import("./settings/Settings_RainbowGirls3s_1080_PP")).Settings_RainbowGirls3s_1080_PP();
        }
        else if (requestedSettings == "fillingpotrainbowgirls3s-720")
        {
            settings = new (await import("./settings/Settings_RainbowGirls3s_720")).Settings_RainbowGirls3s_720();
        }
        else if (requestedSettings == "fillingpotrainbowgirls3s-720-pp")
        {
            settings = new (await import("./settings/Settings_RainbowGirls3s_720_PP")).Settings_RainbowGirls3s_720_PP();
        }
        else if (requestedSettings == "fillingpot-2s1080")
        {
            settings = new (await import("./settings/Settings_FillingPot_2s1080")).Settings_FillingPot_2s1080();
        }
        else if (requestedSettings == "fillingpot-2s1080-pp")
        {
            settings = new (await import("./settings/Settings_FillingPot_2s1080_PP")).Settings_FillingPot_2s1080_PP();
        }
        else if (requestedSettings == "fillingpot3s-720-botonera720")
        {
            settings = new (await import("./settings/Settings_FillingPot720_Botonera720")).Settings_FillingPot720_Botonera720();
        }
        else if (requestedSettings == "fillingpot3s-720-botonera720")
        {
            settings = new (await import("./settings/Settings_FillingPot720_Botonera720_PP")).Settings_FillingPot720_Botonera720_PP();
        }
        else if (requestedSettings == "fillingpotdiamond2s-720")
        {
            settings = new (await import("./settings/Settings_FillingPot_DiamondPot_2S_720")).Settings_FillingPot_DiamondPot_2S_720();
        }
        else if (requestedSettings == "fillingpotdiamond2s-720-pp")
        {
            settings = new (await import("./settings/Settings_FillingPot_DiamondPot_2S_720_PP")).Settings_FillingPot_DiamondPot_2S_720_PP();
        }
        else if (requestedSettings == "fillingpotdiamond3s-720-botonera720")
        {
            settings = new (await import("./settings/Settings_FillingPot_DiamondPot_3S_720_Bottonera720")).Settings_FillingPot_DiamondPot_3S_720_Bottonera720();
        }
        else if (requestedSettings == "fillingpotdiamond3s-720-botonera720-pp")
        {
            settings = new (await import("./settings/Settings_FillingPot_DiamondPot_3S_720_Bottonera720_PP")).Settings_FillingPot_DiamondPot_3S_720_Bottonera720_PP();
        }
        else if (requestedSettings == "fillingpotdiamond2s-1080")
        {
            settings = new (await import("./settings/Settings_FillingPot_DiamondPot_2S_1080")).Settings_FillingPot_DiamondPot_2S_1080();
        }
        else if (requestedSettings == "fillingpotdiamond2s-1080-pp")
        {
            settings = new (await import("./settings/Settings_FillingPot_DiamondPot_2S_1080_PP")).Settings_FillingPot_DiamondPot_2S_1080_PP();
        }
        else if (requestedSettings == "fillingpotdiamond2s-720-virtualbotonera")
        {
            settings = new (await import("./settings/Settings_FillingPot_DiamondPot_2S_720_VirtualBotonera")).Settings_FillingPot_DiamondPot_2S_720_VirtualBotonera();
        }
        else if (requestedSettings == "fillingpotdiamond2s-720-virtualbotonera-pp")
        {
            settings = new (await import("./settings/Settings_FillingPot_DiamondPot_2S_720_VirtualBotonera_PP")).Settings_FillingPot_DiamondPot_2S_720_VirtualBotonera_PP();
        }
        else if (requestedSettings == "fillingpotdiamond2s-1080-virtualbotonera")
        {
            settings = new (await import("./settings/Settings_FillingPot_DiamondPot_2S_1080_VirtualBotonera")).Settings_FillingPot_DiamondPot_2S_1080_VirtualBotonera();
        }
        else if (requestedSettings == "fillingpotdiamond2s-1080-virtualbotonera-pp")
        {
            settings = new (await import("./settings/Settings_FillingPot_DiamondPot_2S_1080_VirtualBotonera_PP")).Settings_FillingPot_DiamondPot_2S_1080_VirtualBotonera_PP();
        }
        else if (requestedSettings == "fillingpotsinglediamond2s-720")
        {
            settings = new (await import("./settings/Settings_FillingPot_SingleGame_DiamondPot_2S_720")).Settings_FillingPot_SingleGame_DiamondPot_2S_720();
        }
        else if (requestedSettings == "fillingpotsinglediamond2s-720-pp")
        {
            settings = new (await import("./settings/Settings_FillingPot_SingleGame_DiamondPot_2S_720_PP")).Settings_FillingPot_SingleGame_DiamondPot_2S_720_PP();
        }
        else if (requestedSettings == "fillingpotsinglediamond2s-1080")
        {
            settings = new (await import("./settings/Settings_FillingPot_SingleGame_DiamondPot_2S_1080")).Settings_FillingPot_SingleGame_DiamondPot_2S_1080();
        }
        else if (requestedSettings == "fillingpotsinglediamond2s-1080-pp")
        {
            settings = new (await import("./settings/Settings_FillingPot_SingleGame_DiamondPot_2S_1080_PP")).Settings_FillingPot_SingleGame_DiamondPot_2S_1080_PP();
        }
        else if (requestedSettings == "fillingpot3s-720-virtualbotonera")
        {
            settings = new (await import("./settings/Settings_FillingPot720VirtualBotonera")).Settings_FillingPot720VirtualBotonera();
        }  
        else if (requestedSettings == "fillingpot3s-720-virtualbotonera-pp")
        {
            settings = new (await import("./settings/Settings_FillingPot720VirtualBotonera_PP")).Settings_FillingPot720VirtualBotonera_PP();
        }  
        else if (requestedSettings == "fillingpot3s-720-virtualbotonera-shared-pp")
        {
            settings = new (await import("./settings/Settings_FillingPotDiamondPotStepShared720VirtualBotonera_PP")).Settings_FillingPotDiamondPotStepShared720VirtualBotonera_PP();
        }  
        else if (requestedSettings == "fillingpot3s-720-virtualbotonera-noshared-pp")
        {
            settings = new (await import("./settings/Settings_FillingPotDiamondPotStepNoShared720VirtualBotonera_PP")).Settings_FillingPotDiamondPotStepNoShared720VirtualBotonera_PP();
        }  
        else if (requestedSettings == "fillingpot3s1080-rapidlink")
        {
            settings = new (await import("./settings/Settings_RapidLinkFillingPot3s_1080")).Settings_RapidLinkFillingPot3s_1080();
        }
        else if (requestedSettings == "fillingpot3s1080-rapidlink-pp")
        {
            settings = new (await import("./settings/Settings_RapidLinkFillingPot3s_1080_PP")).Settings_RapidLinkFillingPot3s_1080_PP();
        }   
        else if (requestedSettings == "fillingpot2s1080-rapidlink")
        {
            settings = new (await import("./settings/Settings_RapidLinkFillingPot2s_1080")).Settings_RapidLinkFillingPot2s_1080();
        } 
        else if (requestedSettings == "fillingpot2s1080-rapidlink-pp")
        {
            settings = new (await import("./settings/Settings_RapidLinkFillingPot2s_1080_PP")).Settings_RapidLinkFillingPot2s_1080_PP();
        }
        else if (requestedSettings == "fillingpot3s720-rapidlink")
        {
            settings = new (await import("./settings/Settings_RapidLinkFillingPot3s_720")).Settings_RapidLinkFillingPot3s_720();
        }  
        else if (requestedSettings == "fillingpot3s720-rapidlink-pp")
        {
            settings = new (await import("./settings/Settings_RapidLinkFillingPot3s_720_PP")).Settings_RapidLinkFillingPot3s_720_PP();
        } 
        else if (requestedSettings == "fillingpot2s720-rapidlink")
        {
            settings = new (await import("./settings/Settings_RapidLinkFillingPot2s_720")).Settings_RapidLinkFillingPot2s_720();
        }    
        else if (requestedSettings == "fillingpot2s720-rapidlink-pp")
        {
            settings = new (await import("./settings/Settings_RapidLinkFillingPot2s_720_PP")).Settings_RapidLinkFillingPot2s_720_PP();
        } 
        else if (requestedSettings == "fillingpot2s1080-diamondpotsteprapidframes")
        {
            settings = new (await import("./settings/Settings_FillingPot_DiamondPotStepRappidFrames2s_1080")).Settings_FillingPot_DiamondPotStepRappidFrames2s_1080();
        }
        else if (requestedSettings == "fillingpot2s1080-diamondpotsteprapidframes-pp")
        {
            settings = new (await import("./settings/Settings_FillingPot_DiamondPotStepRappidFrames2s_1080_PP")).Settings_FillingPot_DiamondPotStepRappidFrames2s_1080_PP();
        }
        else if (requestedSettings == "fillingpot2s720-diamondpotsteprapidframes")
        {
            settings = new (await import("./settings/Settings_FillingPot_DiamondPotStepRappidFrames2s_720")).Settings_FillingPot_DiamondPotStepRappidFrames2s_720();
        }     
        else if (requestedSettings == "fillingpot2s720-diamondpotsteprapidframes-pp")
        {
            settings = new (await import("./settings/Settings_FillingPot_DiamondPotStepRappidFrames2s_720_PP")).Settings_FillingPot_DiamondPotStepRappidFrames2s_720_PP();
        }    
        else if (requestedSettings == "fillingpot2s1080-diamondpotsteprapidframes-virtualbotonera")
        {
            settings = new (await import("./settings/Settings_FillingPot_DiamondPotStepRappidFrames2s_1080_VirtualBotonera")).Settings_FillingPot_DiamondPotStepRappidFrames2s_1080_VirtualBotonera();
        }
        else if (requestedSettings == "fillingpot2s720-diamondpotsteprapidframes-virtualbotonera")
        {
            settings = new (await import("./settings/Settings_FillingPot_DiamondPotStepRappidFrames2s_720_VirtualBotonera")).Settings_FillingPot_DiamondPotStepRappidFrames2s_720_VirtualBotonera();
        }
        else if (requestedSettings == "fillingpot2s720-diamondpotsteprapidframes-virtualbotonera-pp")
        {
            settings = new (await import("./settings/Settings_FillingPot_DiamondPotStepRappidFrames2s_720_VirtualBotonera_PP")).Settings_FillingPot_DiamondPotStepRappidFrames2s_720_VirtualBotonera_PP();
        }
        else if(requestedSettings == "fillingpot3s-720-Ideck")
        {
            settings = new (await import("./settings/Settings_FillingPot720_3s_Ideck")).Settings_FillingPot720_3s_Ideck();
        }
        else if(requestedSettings == "fillingpot3s-720-Ideck-pp")
        {
            settings = new (await import("./settings/Settings_FillingPot720_3s_Ideck_PP")).Settings_FillingPot720_3s_Ideck_PP();
        } 
        else if (requestedSettings == "fillingpot3s1080-diamondpotstepshared2plus1") {
            settings = new (await import("./settings/Settings_FillingPot1080_DiamondPotStepShared2Plus1")).Settings_FillingPot1080_DiamondPotStepShared2Plus1();
        }
        else if (requestedSettings == "fillingpot3s720-diamondpotstepshared2plus1") {
            settings = new (await import("./settings/Settings_FillingPot720_DiamondPotStepShared2Plus1")).Settings_FillingPot720_DiamondPotStepShared2Plus1();
        }
        else if (requestedSettings == "fillingpot3s720-diamondpotstepshared2plus1-pp")
        {
            settings = new (await import("./settings/Settings_FillingPot720_DiamondPotStepShared2Plus1_PP")).Settings_FillingPot720_DiamondPotStepShared2Plus1_PP();
        }
        else if (requestedSettings == "fillingpot3s1080-diamondpotstepshared") {
            settings = new (await import("./settings/Settings_FillingPot1080_DiamondPotStepShared")).Settings_FillingPot1080_DiamondPotStepShared();
        }
        else if (requestedSettings == "fillingpot3s1080-diamondpotstepshared-pp") {
            settings = new (await import("./settings/Settings_FillingPot1080_DiamondPotStepShared_PP")).Settings_FillingPot1080_DiamondPotStepShared_PP();
        }
        else if (requestedSettings == "fillingpot3s720-diamondpotstepshared") {
            settings = new (await import("./settings/Settings_FillingPot720_DiamondPotStepShared")).Settings_FillingPot720_DiamondPotStepShared();
        }
        else if (requestedSettings == "fillingpot3s720-diamondpotstepshared-curva") {
            settings = new (await import("./settings/Settings_FillingPot720_DiamondPotStepShared_Curva")).Settings_FillingPot720_DiamondPotStepShared_Curva();
        }
        else if (requestedSettings == "fillingpot3s720-diamondpotstepshared-virtualbotonera") {
            settings = new (await import("./settings/Settings_FillingPot720_DiamondPotStepShared_VirtualBotonera")).Settings_FillingPot720_DiamondPotStepShared_VirtualBotonera();
        }
        else if (requestedSettings == "fillingpot3s720-diamondpotstepshared-pp") {
            settings = new (await import("./settings/Settings_FillingPot720_DiamondPotStepShared_PP")).Settings_FillingPot720_DiamondPotStepShared_PP();
        }
        else if (requestedSettings == "fillingpot2s720-diamondpotstepshared") {
            settings = new (await import("./settings/Settings_FillingPot720_2s_DiamondPotStepShared")).Settings_FillingPot720_2s_DiamondPotStepShared();
        }
        else if (requestedSettings == "fillingpot2s720-diamondpotstepshared-pp")
        {
            settings = new (await import("./settings/Settings_FillingPot720_2s_DiamondPotStepShared_PP")).Settings_FillingPot720_2s_DiamondPotStepShared_PP()
        }
        else if (requestedSettings == "fillingpot3s720-diamondpotstepnoshared")
        {
            settings = new (await import("./settings/Settings_FillingPot720_DiamondPotStepNoShared")).Settings_FillingPot720_DiamondPotStepNoShared();
        }
        else if (requestedSettings == "fillingpot3s720-diamondpotstepnoshared2p1")
        {
            settings = new (await import("./settings/Settings_FillingPot720_DiamondPotStepNoShared2p1")).Settings_FillingPot720_DiamondPotStepNoShared2p1();
        }
        else if (requestedSettings == "fillingpot3s720-diamondpotstepnoshared2p1-pp")
        {
            settings = new (await import("./settings/Settings_FillingPot720_DiamondPotStepNoShared2p1_PP")).Settings_FillingPot720_DiamondPotStepNoShared2p1_PP();
        }
        else if (requestedSettings == "fillingpot3s1080-diamondpotstepnoshared2p1")
        {
            settings = new (await import("./settings/Settings_FillingPot1080_DiamondPotStepNoShared2p1")).Settings_FillingPot1080_DiamondPotStepNoShared2p1();
        }
        else if (requestedSettings == "fillingpot3s1080-diamondpotstepnoshared2p1-pp")
        {
            settings = new (await import("./settings/Settings_FillingPot1080_DiamondPotStepNoShared2p1_PP")).Settings_FillingPot1080_DiamondPotStepNoShared2p1_PP();
        }
        else if (requestedSettings == "fillingpot3s720-diamondpotstepnoshared-pp")
        {
            settings = new (await import("./settings/Settings_FillingPot720_DiamondPotStepNoShared_PP")).Settings_FillingPot720_DiamondPotStepNoShared_PP()
        }
        else if (requestedSettings == "fillingpot3s1080-diamondpotstepnoshared")
        {
            settings = new (await import("./settings/Settings_FillingPot1080_DiamondPotStepNoShared")).Settings_FillingPot1080_DiamondPotStepNoShared()
        }
        else if (requestedSettings == "fillingpot3s1080-diamondpotstepnoshared-pp")
        {
            settings = new (await import("./settings/Settings_FillingPot1080_DiamondPotStepNoShared_PP")).Settings_FillingPot1080_DiamondPotStepNoShared_PP()
        }
        else if (requestedSettings == "fillingpot2s720-diamondpotstepshared-virtualbotonera-pp")
        {
            settings = new (await import("./settings/Settings_FillingPot720_DiamondPotStepShared_VirtualBotonera_PP")).Settings_FillingPot720_DiamondPotStepShared_VirtualBotonera_PP()
        }
        else if (requestedSettings == "fillingpot2s720-diamondpotstepnoshared-virtualbotonera")
        {
            settings = new (await import("./settings/Settings_FillingPot2s720_DiamondPotStepNoShared_VirtualBotonera")).Settings_FillingPot2s720_DiamondPotStepNoShared_VirtualBotonera()
        }
        else if (requestedSettings == "fillingpot2s720-diamondpotstepnoshared-virtualbotonera-pp")
        {
            settings = new (await import("./settings/Settings_FillingPot2s720_DiamondPotStepNoShared_VirtualBotonera_PP")).Settings_FillingPot2s720_DiamondPotStepNoShared_VirtualBotonera_PP()
        }
        else if (requestedSettings == "fillingpot2s720-diamondpotstepnoshared")
        {
            settings = new (await import("./settings/Settings_FillingPot2s720_DiamondPotStepNoShared")).Settings_FillingPot2s720_DiamondPotStepNoShared()
        }
        else if (requestedSettings == "fillingpot2s720-diamondpotstepnoshared-pp")
        {
            settings = new (await import("./settings/Settings_FillingPot2s720_DiamondPotStepNoShared_PP")).Settings_FillingPot2s720_DiamondPotStepNoShared_PP()
        }

        //New Jackpot Settings 
        else if (requestedSettings == "fillingpot3s720-diamondpotpyramidshare") {
            settings = new (await import("./settings/Settings_FillingPot3S_720_DiamondPotPyramidShared")).Settings_FillingPot3S_720_DiamondPotPyramidShared();
        }
        else if (requestedSettings == "fillingpot3s720-diamondpotpyramidsinshare") {
            settings = new (await import("./settings/Settings_FillingPot3S_720_DiamondPotPyramidSinShared")).Settings_FillingPot3S_720_DiamondPotPyramidSinShared();
        }
        else if (requestedSettings == "fillingpot2s720-diamondpotpyramidshare") {
            settings = new (await import("./settings/Settings_FillingPot2S_720_DiamondPotPyramidShared")).Settings_FillingPot2S_720_DiamondPotPyramidShared();
        }
        else if (requestedSettings == "fillingpot2s720-diamondpotpyramidsinshare") {
            settings = new (await import("./settings/Settings_FillingPot2S_720_DiamondPotPyramidSinShared")).Settings_FillingPot2S_720_DiamondPotPyramidSinShared();
        }
        else if (requestedSettings == "fillingpot3s720-diamondpotpyramidjp4sharejp3sinshare") {
            settings = new (await import("./settings/Settings_FillingPot720_DiamondPotPyramidJP4ShareJP3SinShared")).Settings_FillingPot720_DiamondPotPyramidJP4ShareJP3SinShared();
        }   
        else if (requestedSettings == "fillingpot3s720-diamondpotpyramidshare-pp") {
            settings = new (await import("./settings/Settings_FillingPot3S_720_DiamondPotPyramidShared_PP")).Settings_FillingPot3S_720_DiamondPotPyramidShared_PP();
        }
        else if (requestedSettings == "fillingpot2s720-diamondpotpyramidshare2s-pp") {
            settings = new (await import("./settings/Settings_FillingPot2S_720_DiamondPotPyramidShared2S_PP")).Settings_FillingPot2S_720_DiamondPotPyramidShared2S_PP();
        }
        else if (requestedSettings == "fillingpot2s720-diamondpotpyramidsinshare2s-pp") {
            settings = new (await import("./settings/Settings_FillingPot2S_720_DiamondPotPyramidSinShared2S_PP")).Settings_FillingPot2S_720_DiamondPotPyramidSinShared2S_PP();
        }
        else if (requestedSettings == "fillingpot2s720-diamondpotpyramidjp4sharejp3sinshare2s-pp") {
            settings = new (await import("./settings/Settings_FillingPot2S_720_DiamondPotPyramidJP4SharedJP3SinShared2S_PP")).Settings_FillingPot2S_720_DiamondPotPyramidJP4SharedJP3SinShared2S_PP();
        }
        else if (requestedSettings == "fillingpot3s720-diamondpotpyramidsinshare-pp") {
            settings = new (await import("./settings/Settings_FillingPot3S_720_DiamondPotPyramidSinShared_PP")).Settings_FillingPot3S_720_DiamondPotPyramidSinShared_PP();
        }
        else if (requestedSettings == "fillingpot2s720-diamondpotpyramidshare-pp") {
            settings = new (await import("./settings/Settings_FillingPot2S_720_DiamondPotPyramidShared_PP")).Settings_FillingPot2S_720_DiamondPotPyramidShared_PP();
        }
        else if (requestedSettings == "fillingpot2s720-diamondpotpyramidsinshare-pp") {
            settings = new (await import("./settings/Settings_FillingPot2S_720_DiamondPotPyramidSinShared_PP")).Settings_FillingPot2S_720_DiamondPotPyramidSinShared_PP();
        }      
        //Settings2P1 
        else if (requestedSettings == "fillingpot3s720-diamondpotpyramidshare2p1") {
            settings = new (await import("./settings/Settings_FillingPot3S_720_DiamondPotPyramidShared2p1")).Settings_FillingPot3S_720_DiamondPotPyramidShared2p1();
        }
        else if (requestedSettings == "fillingpot3s720-diamondpotpyramidsinshare2p1") {
            settings = new (await import("./settings/Settings_FillingPot3S_720_DiamondPotPyramidSinShared2p1")).Settings_FillingPot3S_720_DiamondPotPyramidSinShared2p1();
        }        
        //Settings2p1-PP        
        else if (requestedSettings == "fillingpot3s720-diamondpotpyramidshare2p1-pp") {
            settings = new (await import("./settings/Settings_FillingPot3S_720_DiamondPotPyramidShared2p1_PP")).Settings_FillingPot3S_720_DiamondPotPyramidShared2p1_PP();
        }
        else if (requestedSettings == "fillingpot3s720-diamondpotpyramidsinshare2p1-pp") {
            settings = new (await import("./settings/Settings_FillingPot3S_720_DiamondPotPyramidSinShared2p1_PP")).Settings_FillingPot3S_720_DiamondPotPyramidSinShared2p1_PP();
        } 
        //virtualbotonera
        else if (requestedSettings == "Settings_FillingPot720_DiamondPotPyramidShared_VirtualBotonera_PP")
        {
            settings = new (await import("./settings/Settings_FillingPot720_DiamondPotPyramidShared_VirtualBotonera_PP")).Settings_FillingPot720_DiamondPotPyramidShared_VirtualBotonera_PP()
        }
        //End New Jackpot Settings    
        else if (requestedSettings == "classic2s1080")
        {
            settings = new (await import("./settings/Settings_ClassicNoJackpot2S_1080")).Settings_ClassicNoJackpot2S_1080();
        }
        else if (requestedSettings == "purplediamondpot")
        {
            settings = new (await import("./settings/Settings_PurpleDiamondPot")).Settings_PurpleDiamondPot();
        }
        else if (requestedSettings == "purplediamondpot-pp")
        {
            settings = new (await import("./settings/Settings_PurpleDiamondPot_PP")).Settings_PurpleDiamondPot_PP();
        }
        else if (requestedSettings == "purplefirenze")
        {
            settings = new (await import("./settings/Settings_PurpleFirenze")).Settings_PurpleFirenze();
        }
        else if (requestedSettings == "purplefirenze-pp")
        {
            settings = new (await import("./settings/Settings_PurpleFirenze_PP")).Settings_PurpleFirenze_PP();
        }
        else if (requestedSettings == "rapidlinkpga")
        {
            settings = new (await import("./settings/Settings_RapidLinkPGA")).Settings_RapidLinkPGA();
        }
        else if (requestedSettings == "rapidlinkpga-pp")
        {
            settings = new (await import("./settings/Settings_RapidLinkPGA_PP")).Settings_RapidLinkPGA_PP();
        }
        else if (requestedSettings == "singlegame")
        {
            settings = new (await import("./settings/Settings_SingleGameDiamondPotStep")).Settings_SingleGameDiamondPotStep();
        }
        else if (requestedSettings == "singlegame-pp")
        {
            settings = new (await import("./settings/Settings_SingleGameDiamondPotStep_PP")).Settings_SingleGameDiamondPotStep_PP();
        }
        else if (requestedSettings === undefined || requestedSettings === null)
        {
            settings = new (await import("./settings/Classic")).Classic();
        }
        // else
        // {
        //     assertNever(`Unimplemented settings ${requestedSettings}`);
        // }
        

        console.log("CreateSettings()", settings);

        return settings;
    }
}

// export class Settings
// {
//     protected static instance: ISettings = new SettingsFactory().CreateSettings();
//     public static get Instance(): ISettings
//     {
//         return Settings.instance;
//     }
// }

export const FruitGames: string[] = [
    "BurningFruits20",
    "BurningFruits40",
    "BurningFruits5",
    "FireBlastClassic",
    "FireBlastDeluxClassic",
    "IceBlastDeluxClassic",
    "IceBlast",
    "LuckyFire100",
    "LuckyFire10",
    "LuckyFire20",
    "LuckyFire40Delux",
    "LuckyFire40",
    "LuckyFire5",
    "LuckyIce100",
    "LuckyIce10",
    "LuckyIce20",
    "LuckyIce40Delux",
    "LuckyIce40",
    "LuckyIce5",
    "RoyalChalice",
    "RoyalDice",
    "RoyalKingDeluxe",
    "RoyalKing",
    "ShiningChalice",
    "StickyChilliClassic",
    "TikiBayClassic",
    "WildChalice",

]

let settingsFactory: SettingsFactory = new SettingsFactory();
export let Settings = settingsFactory.CreateDefaultSettings();

export async function ChangeSettings(settingsName: string)
{
    console.log("Changing settings to " + settingsName);
    Settings = await settingsFactory.CreateSettings(settingsName);
}


//export const MonitorScreenWidth : number = 1080;
//export const MonitorScreenHeight : number =  1920;
